import { post, postData } from '../../util/Api';
import { DailyReport } from './DailyReportModel';

export interface DailyReportRead {
  id: number;
  daily_report_id: number;
  user_id: number;
  read_at: Date;
  created_at: Date;
  updated_at: Date;
}

export class DailyReportReadModel {
  /**
   * 日報を既読にする
   * @param dailyReport 対象の日報
   * @returns Promise<void>
   */
  static async markAsRead(dailyReport: DailyReport): Promise<void> {
    await postData(`/daily-report/${dailyReport.id}/mark-as-read`);
  }

  /**
   * 該当の日報を全て既読にする
   * @param dailyReport 対象の日報
   * @returns Promise<void>
   */
  static async allMarkAsReadByDailyReport(dailyReport: DailyReport): Promise<void> {
    if (!dailyReport.id) {
      throw new Error('日報が指定されていません。');
    }

    await postData(`/daily-report/${dailyReport.id}/all-mark-as-read`);
  }

  /**
   * 全ての日報を既読にする
   * @param dailyReport 対象の日報
   * @returns Promise<void>
   */
  static async allMarkAsRead(): Promise<void> {
    await postData(`/daily-report/all-mark-as-read`);
  }

  /**
   * 未読が存在する日報の件数を取得する
   * @returns 未読が存在する日報の件数
   */
  static async allUnreadCount(): Promise<number> {
    const response = await postData(`/daily-report/all-unread-count`);
    return response.data ?? 0;
  }

  /**
   * 日報の既読状態を取得する
   * @param dailyReport 対象の日報
   * @returns Promise<boolean> 既読状態
   */
  static async checkReadStatus(dailyReport: DailyReport): Promise<boolean> {
    const response = await postData(`/daily-report/${dailyReport.id}/check-read-status`);
    return response.data.is_read || false;
  }
}
